import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { CustomerFilterSchema } from "@redotech/redo-model/customer-filter";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { PreviewCustomerSchema } from "./get-vanguard-preview-customers";

export const getCustomersByEventData = {
  name: "getCustomersByEventData" as const,
  input: z.object({
    filters: CustomerFilterSchema,
    limit: z.number().min(1).max(25),
    schemaType: createEnum(SchemaType, { enumName: "SchemaType" }).optional(),
  }),
  output: z.object({
    customers: z.array(PreviewCustomerSchema),
    totalCount: z.number(),
  }),
};
